import React from 'react'
import _ from 'lodashParts'

import FontFamilyPicker from 'wix-base-ui/lib/controls/fontFamilyPicker'

function buildGroupedFontsArray(fonts) {
    const groupedFonts = {}

    _.forEach(fonts.fonts, font => {
        if (!groupedFonts[font.lang]) {
            groupedFonts[font.lang] = []
        }

        groupedFonts[font.lang].push(font)
    })

    const retVal = []
    _.forEach(fonts.languages, lang => {
        retVal.push({
            fonts: groupedFonts[lang],
            lang
        })
    })

    return retVal
}

function getFirstFontInMap(fontsMap) {
    const keys = Object.keys(fontsMap || {})

    return keys[0] && fontsMap[keys[0]].fontFamily
}
function isMissingFont(value, fontsArr) {
    return !_.find(fontsArr, {fontFamily: value})
}

function getMissingFontDisplayName(value) {
    return value
}

function getValueState(fontsObj, value) {
    let calculatedValue = value
    let missingFontPlaceholder = null
    if (value) {
        if (isMissingFont(value, fontsObj.fonts)) {
            missingFontPlaceholder = getMissingFontDisplayName(value)
        }
    } else {
        calculatedValue = getFirstFontInMap(fontsObj.fonts)
    }

    return {
        value: calculatedValue,
        placeholder: missingFontPlaceholder
    }
}

class FontDropDown extends React.Component {
    constructor(props) {
        super(props)

        const fonts = buildGroupedFontsArray(props.fonts)
        this.state = _.assign({fonts}, getValueState(props.fonts, props.value))
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.fonts !== this.props.fonts || this.props.value !== nextProps.value
    }

    componentWillReceiveProps(nextProps) {
        let newState = {}
        if (nextProps.fonts !== this.props.fonts) {
            newState.fonts = buildGroupedFontsArray(nextProps.fonts)
        }

        if (!nextProps.value || this.props.value !== nextProps.value) {
            newState = _.assign(newState, getValueState(nextProps.fonts, nextProps.value))
        }

        if (newState !== {}) {
            this.setState(newState)
        }
    }

    handleFontFamilyChanged(value) {
        const fontFamily = value
        this.props.execCommand('fontFamily', fontFamily)
    }

    getMissingFontName(val) {
        return val
    }

    render() {
        if (this.state.fonts && this.state.fonts.length > 0) {
            return (
                <FontFamilyPicker
                    automationId="fonts-drop-down"
                    className="richtext-dropdown richtext-fonts-dropdown"
                    fonts={this.state.fonts}
                    value={this.state.value}
                    onChange={ val => this.handleFontFamilyChanged(val)}
                    getMissingFontName={this.getMissingFontName}
                    toolbarMode={true}/>
            )
        }

        return null
    }
}

FontDropDown.propTypes = {
    fonts: React.PropTypes.object.isRequired,
    value: React.PropTypes.string,
    translate: React.PropTypes.func.isRequired,
    execCommand: React.PropTypes.func
}

module.exports = FontDropDown



// WEBPACK FOOTER //
// ./src/components/toolbar/fontDropDown.jsx